module.exports = __webpack_public_path__ + "img/alarm-parameter.0e92fa10.png";